"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
var NotificationType;
(function (NotificationType) {
    NotificationType["PROFILE_FOLLOWING"] = "profile_following";
    NotificationType["LIKE"] = "like";
    NotificationType["CONTENT_PURCHASE"] = "content_purchase";
    NotificationType["SUBSCRIPTION_PURCHASE"] = "subscription_purchase";
    NotificationType["PUBLIC_LIVECHAT"] = "public_livechat";
})(NotificationType = exports.NotificationType || (exports.NotificationType = {}));
class NotificationsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Notification: () => `
        ... on Notification {
          id
          recipientId
          userId
          user {
            ${this.getFragment("UserPublicData")}
          }
          type
          subjectId
          time
          details {
            __typename
            ${this.getFragment("NotificationDetails")}
          }          
        }
      `,
        };
    }
    find({ data }) {
        return this.query("notificationsFind", { data }, this.getPageableFragment("Notification"));
    }
    subscribeNotification(onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
            subscription Notification {
                notification {
                    ${this.getFragment("Notification")}
                }
            }
        `,
        }, data => {
            onData(data.notification);
        }, onError);
    }
}
exports.NotificationsProvider = NotificationsProvider;
//# sourceMappingURL=NotificationsProvider.js.map